/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { useTranslation } from "react-i18next";
import { AuroraBackground } from "@/components/AuroraBackground";
import { Reveal } from "@/components/Reveal";
import { StoreBadgeGroup } from "@/components/StoreBadges";
import { AlertCircle } from "lucide-react";

const CounselingVsDivorcePage = () => {
  const { t } = useTranslation("site");
  const tk = (k, fb) => t(`counseling.${k}`, fb);
  return (
    <>
      <section className="relative pb-12">
        <AuroraBackground variant="soft" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8 pt-8 lg:pt-12">
          <Reveal>
            <p className="eyebrow">{tk("kicker")}</p>
            <h1 className="mt-3 font-serif text-[2.4rem] sm:text-5xl lg:text-[4rem] tracking-tight font-light leading-[1.05] max-w-4xl">
              {tk("title1")}{" "}<em className="italic aurora-shimmer-text">{tk("title2")}</em>
            </h1>
            <p className="mt-6 max-w-2xl text-white/72 text-lg font-light">{tk("subtitle")}</p>
          </Reveal>
        </div>
      </section>

      <section className="relative py-12">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 space-y-10">
          {[
            { h: tk("p1T"), p: tk("p1B") },
            { h: tk("p2T"), p: tk("p2B") },
            { h: tk("p3T"), p: tk("p3B") },
            { h: tk("p4T"), p: tk("p4B") },
          ].map((s) => (
            <Reveal key={s.h}>
              <h2 className="font-serif text-2xl sm:text-3xl font-normal">{s.h}</h2>
              <p className="mt-3 text-white/75 font-light text-lg leading-relaxed">{s.p}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="relative py-16">
        <div className="mx-auto max-w-4xl px-5 lg:px-8">
          <Reveal>
            <div className="aurora-glass p-6 lg:p-10 border-l-4 border-[var(--aurora-gold)]">
              <div className="flex items-start gap-3">
                <AlertCircle className="text-[var(--aurora-gold)] mt-1 shrink-0" size={20} />
                <div>
                  <p className="font-serif text-xl">{tk("safetyT")}</p>
                  <p className="mt-2 text-white/75 font-light leading-relaxed">{tk("safetyB")}</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="relative py-20">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 text-center">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-4xl tracking-tight font-light">
              {tk("closingTitle1")}{" "}<em className="italic text-[var(--aurora-gold)]">{tk("closingTitle2")}</em>{tk("closingTitle3")}
            </h2>
            <p className="mt-4 text-white/72 font-light">{tk("closingBody")}</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <StoreBadgeGroup startLabel={t("common.startFree")} />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default CounselingVsDivorcePage;
